module.exports = __webpack_public_path__ + "img/bt-logo.778d47fc.png";